function createConfig(initialState){  
  const conf_store = initialState || {};

  return {
    set: (key, value) => conf_store[key] = value,
    get: (key, defaultValue) => conf_store[key] || defaultValue
  }
};

export default createConfig();
